import { Option } from "@jutro/types";
import { Avatar, Button, PencilIcon } from "@jutro/ui";
import { envVars } from "envvars";
import { avatarConfig } from "lib/tools/httpConfigs";
import { StaffOption } from "views/StaffSchedule/StaffScheduleCreator/tools";

type Props = {
  staff: Option<StaffOption>;
  handleStaffDetailsActionModalOpen: (
    staff: Option<StaffOption> | null,
  ) => void;
};

export const StaffDetails = ({
  staff,
  handleStaffDetailsActionModalOpen,
}: Props) => {
  return (
    <div className="flex w-full flex-col gap-1">
      <div className="flex justify-between">
        <Avatar
          type="photo"
          imgSrc={`${avatarConfig[envVars.REACT_APP_CONFIG]}/${staff.value.id}`}
          size="md"
        />
        <div className="hidden group-hover:flex">
          <Button
            icon={<PencilIcon />}
            label="staffDetailsEdit"
            size="condensed"
            variant="ghost"
            type="button"
            full={false}
            withTooltip={false}
            onClick={() => handleStaffDetailsActionModalOpen(staff)}
          />
        </div>
      </div>
      <span className="font-label">{staff.label}</span>
      <div className="flex flex-col">
        <span>
          {formatWorkTime(staff.value.workedHours?.alreadyWorkedHours)} /{" "}
          {formatWorkTime(staff.value.workedHours?.expectedWorkingHours)}
        </span>
        <span className="text-jutro-new-warm-gray-600">
          {`${formatWorkTime(staff.value.workedHours?.hoursToWorkLeft)}`}
        </span>
      </div>
    </div>
  );
};

const formatWorkTime = (workTime: string | null | undefined) => {
  if (!workTime) {
    return "0h 00min";
  }

  const [hour, minute] = workTime.split(":").map(Number);
  return `${hour}h ${minute}min`;
};
